<template>
	<div class="flex-wrapper">
		<div>
			<TnParagraph size="s">Å betale</TnParagraph>
		</div>
		<div class="total-amount-flex-wrapper">
			<div class="single-amount">
				<TnParagraph size="s"> Månedspris </TnParagraph>
				<TnParagraph
					size="s"
					bold
				>
					{{ formatPrice.monthly(monthlyAmount) }}
				</TnParagraph>
			</div>
			<div class="single-amount">
				<TnParagraph size="s"> Betale nå </TnParagraph>
				<TnParagraph
					size="s"
					bold
				>
					{{ formatPrice.oneTime(oneTimeAmount) }}
				</TnParagraph>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { formatPrice } from "~/helpers/formatting/price";

const { monthlyAmount, oneTimeAmount } = defineProps<{
	monthlyAmount: number;
	oneTimeAmount: number;
}>();
</script>

<style lang="scss" scoped>
.flex-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	box-sizing: border-box;

	.total-amount-flex-wrapper {
		display: flex;
		justify-content: flex-end;
		gap: 24px;

		.single-amount {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			gap: 16px;
		}
	}
}
</style>
